import api from "../Api";
import { BaseService } from "../BaseService";


const URL = 'tags';

export class TagsService extends BaseService {
    async list(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async fetch(params: any): Promise<any> {
        try {
            return this.handleResponse(await api.post(params?.id ? `${URL}/update` : `${URL}/create`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async update(params: any): Promise<any> {
        try {
            return this.handleResponse(await api.put(`${URL}/update`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}